$(() => {
  if (!document.body.classList.contains('event-registration-shell')) {
    return;
  }

  const $body = $('body');
  if (!$body.data('bs.popover')) {
    $body.popover({
      placement: 'top',
      container: 'body',
      html: true,
      selector: '[data-toggle="popover"]',
    });
  }

  $(window)
    .off('scroll.registrationPopover')
    .on('scroll.registrationPopover', () => {
      $('[data-toggle="popover"]').popover('hide');
    });
});
